class ExperimentsStore {
    constructor() {
        this.experiments = {};
    }
    get() {
        return this.experiments;
    }
    set(experiments) {
        this.experiments = experiments;
    }
    enabled(experiment) {
        return this.experiments[experiment] === 'true';
    }
}
const isEnabled = (experiment) => () => getExperiments()[experiment] === 'true';
export const experimentsStore = new ExperimentsStore();
export const getExperiments = () => experimentsStore.get();
export const isVideoHoursDeprecation = isEnabled('specs.vod.videoHoursDeprecation');
export const isStorageQuotaEnabled = isEnabled('specs.vod.storageQuota');
export const isStorageQuotaAnnouncementEnabled = isEnabled('specs.vod.storageQuotaAnnouncement');
//# sourceMappingURL=experiments.js.map